import { computeMergedTheme } from '@owner/theme'
import get from 'lodash/get'

import { useActiveBrand } from '@/core/store'
import globalStore from '@/store'

export const useMergedTheme = {
  computed: {
    coreMergedTheme() {
      const { mergedTheme: coreMergedTheme } = useActiveBrand()
      return coreMergedTheme.value
    },
    mergedTheme() {
      const { brandThemePath, coreMergedTheme, storeModule } = this

      if (brandThemePath) {
        const localTheme = get(
          globalStore.getters[`${storeModule}/currentResource`],
          brandThemePath
        )

        if (localTheme) {
          return computeMergedTheme(localTheme)
        }

        return coreMergedTheme
      } else {
        return coreMergedTheme
      }
    },
  },
  inject: ['brandThemePath', 'storeModule'],
}
